import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { PenLine, CheckCircle2 } from "lucide-react";

export default function ContratoMontadora() {
  const navigate = useNavigate();
  const [ct, setCt] = useState(null);
  const [checks, setChecks] = useState({ a: false, b: false });
  const [otp, setOtp] = useState(null);
  const [codigo, setCodigo] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/auth/contrato-montadora").then((r) => {
      if (r.data.ja_assinado) { navigate("/admin"); return; }
      setCt(r.data);
    }).catch((e) => toast.error(formatApiError(e)));
  }, [navigate]);

  const pedirCodigo = async () => {
    if (!checks.a || !checks.b) { toast.error("Confirme as duas declarações"); return; }
    setBusy(true);
    try {
      const r = await api.post("/auth/contrato-montadora/otp", {});
      setOtp(r.data);
      toast.success("Código enviado por WhatsApp" + (r.data.canais?.email ? " e e-mail" : ""));
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  const assinar = async () => {
    setBusy(true);
    try {
      await api.post("/auth/contrato-montadora/assinar", {
        codigo, declara_representante: checks.a, li_concordo: checks.b });
      toast.success("Contrato assinado! Bem-vinda ao MontaJá 🎉");
      navigate("/admin");
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  if (!ct) return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Carregando contrato…</div>;

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-6 py-10" data-testid="contrato-montadora-page">
        <div className="label-cap"><PenLine size={13} className="inline mr-1" />Primeiro acesso · assinatura obrigatória</div>
        <h1 className="font-heading font-extrabold text-3xl tracking-tighter mt-1">{ct.titulo}</h1>
        <p className="text-xs text-muted-foreground mt-1">Versão {ct.versao} · o aceite fica registrado com data, hora, IP, OTP e hash.</p>
        <div className="mt-4 border border-border bg-secondary/40 p-4 max-h-[28rem] overflow-y-auto whitespace-pre-wrap text-xs"
          data-testid="contrato-montadora-texto">{ct.texto}</div>
        <div className="mt-4 space-y-2 text-sm">
          <label className="flex items-start gap-2 cursor-pointer">
            <input type="checkbox" checked={checks.a} onChange={(e) => setChecks({ ...checks, a: e.target.checked })}
              className="mt-0.5" data-testid="ctm-check-rep" />
            <span>Declaro que sou representante legalmente autorizado da Montadora e possuo poderes para celebrar este contrato.</span>
          </label>
          <label className="flex items-start gap-2 cursor-pointer">
            <input type="checkbox" checked={checks.b} onChange={(e) => setChecks({ ...checks, b: e.target.checked })}
              className="mt-0.5" data-testid="ctm-check-li" />
            <span>Li, compreendi e concordo integralmente com o Contrato Mestre e seus anexos.</span>
          </label>
        </div>
        {!otp ? (
          <Button onClick={pedirCodigo} disabled={busy || !checks.a || !checks.b}
            className="btn-sharp w-full mt-5 h-12 bg-[#FF6700] hover:bg-[#e05a00] text-white font-bold"
            data-testid="ctm-assinar">ASSINAR E CONTINUAR</Button>
        ) : (
          <div className="mt-5 border border-border p-4" data-testid="ctm-otp-bloco">
            <div className="label-cap">Confirme sua assinatura</div>
            <p className="text-xs text-muted-foreground mt-1">
              Código enviado para o WhatsApp final <b>{otp.telefone_final}</b>.
            </p>
            <div className="flex gap-2 mt-3 flex-wrap">
              <Input value={codigo} onChange={(e) => setCodigo(e.target.value)} placeholder="Código (6 dígitos)"
                maxLength={6} className="w-40 text-center tracking-widest font-bold" data-testid="ctm-codigo" />
              <Button onClick={assinar} disabled={busy || codigo.length !== 6}
                className="btn-sharp brand-bg text-white" data-testid="ctm-confirmar">
                <CheckCircle2 size={15} /> CONFIRMAR ASSINATURA
              </Button>
              <Button onClick={pedirCodigo} disabled={busy} variant="ghost" className="text-xs" data-testid="ctm-reenviar">Reenviar código</Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
